/**
 * Progressive disclosure on Order Details: single query param and layout offsets.
 */
export const ORDER_DISCLOSURE_OPEN_QUERY_KEY = "open" as const

/** Canonical section ids (URL `open` value is comma-separated subset, in this order). */
export const ORDER_DISCLOSURE_SECTIONS = ["items", "billing", "timeline", "details", "payment"] as const

export type OrderDisclosureSection = (typeof ORDER_DISCLOSURE_SECTIONS)[number]

/** Sticky / titlebar breathing room for `scrollIntoView` and section `scroll-margin`. */
export const STICKY_OFFSET_PX = 16

export function isOrderDisclosureSection(value: string): value is OrderDisclosureSection {
  return (ORDER_DISCLOSURE_SECTIONS as readonly string[]).includes(value)
}
